//import node_modules
import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import NextImage from "next/legacy/image";

//types
import type { BlogDocument } from "@adjust/libs/database/blogs";

//styles
import { css } from "@adjust/libs/emotion";

const clickableCSS = css({
  color: "black",
  textDecoration: "none",
  [":hover"]: {
    color: "black",
    textDecoration: "underline",
  },
});

const containerCSS = css({
  display: "flex",
  textAlign: "center",
  flexDirection: "column",
  fontFamily: "DM Sans, sans-serif",
  margin: "16px",
});

const wrapperCSS = css({
  display: "block",
  position: "relative",
  margin: "16px",
  height: "272px",
  overflow: "hidden",
  borderRadius: "0.5rem",
  transition: "opacity 0.15s",
});

const imageCSS = css({
  transition: "opacity 0.15s",
  backgroundColor: "#e5e7eb",
  [":hover"]: {
    opacity: 0.7,
  },
});

import getBootstrapSizes from "@adjust/website/libs/helper/getBoostrapSizes";
const sizes = getBootstrapSizes({ xs: 384, md: 256, xxl: 384 });

type BlogPreviewProps = {
  recommendation: BlogDocument;
};

const BlogPreviewComponent: FunctionComponent<BlogPreviewProps> = ({ recommendation }) => {
  const src = recommendation.image.src;
  const href = `/blog/${recommendation.slug}`;

  return (
    <div className={containerCSS}>
      <NextLink href={href}>
        <a className={wrapperCSS}>
          <NextImage
            src={src}
            alt={recommendation.title}
            className={imageCSS}
            sizes={sizes}
            quality={50}
            loading="lazy"
            layout="fill"
            objectFit="cover"
            blurDataURL={recommendation.image.blurDataURL}
            placeholder="blur"
            lazyBoundary="272px"
          />
        </a>
      </NextLink>
      <NextLink href={href}>
        <a className={clickableCSS}>
          <p className="h2">{recommendation.title}</p>
        </a>
      </NextLink>
      <p className="h4">{recommendation.description}</p>
    </div>
  );
};

export default React.memo(BlogPreviewComponent);
